// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container__Vwz4W {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.writeToUsHeader__i0gzB {
  margin: 30px 0 6px 20px;
}

.writeToUsHeaderRedirect__HncTB {
  margin-right: 24px;
  margin-bottom: 5px;
}

.headerText__e0wk9.headerText__e0wk9 {
  overflow: hidden;

  height: 42px;

  font-size: 32px;
  font-weight: 600;
  font-style: normal;
  line-height: 42px;
  color: #fff;
  white-space: nowrap;
}

.formContainer__vGiak.formContainer__vGiak {
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  width: auto;
  height: 100%;
}

.formContainer__vGiak.formContainer__vGiak form {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  margin: 0;
  padding: 0 20px;
}

.formContainer__vGiak::-webkit-scrollbar {
  width: 0;
}

.inputField__WSGfJ.inputField__WSGfJ,
.textareaField__bptdl.textareaField__bptdl {
  width: 100%;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 6px;
}

.inputField__WSGfJ.inputField__WSGfJ input::placeholder,
.textareaField__bptdl.textareaField__bptdl::placeholder,
textarea::placeholder {
  height: 20px;

  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  line-height: 20px;
  color: #8c8c8c;

  opacity: 1;
}

.inputField__WSGfJ.inputField__WSGfJ input,
.textareaField__bptdl.textareaField__bptdl {
  padding: 12px 16px;
  font-size: 14px;
  line-height: 20px;
}

.textareaField__bptdl.textareaField__bptdl {
  resize: vertical;

  width: calc(100% - 32px);
  min-height: 76px;

  border: none;
  outline: none;
}

.sendButton__lT6cm.sendButton__lT6cm {
  overflow: hidden;

  width: 100%;
  height: 46px;
  margin-top: 20px;
  padding: 6px 16px;

  text-transform: none;
  white-space: nowrap;

  border-radius: 6px;
  box-shadow: none;
}

.sendButton__lT6cm.sendButton__lT6cm:hover {
  opacity: 0.9;
  box-shadow: none;
}

.sendButton__lT6cm.sendButton__lT6cm:disabled {
  background-color: rgb(255 255 255 / 50%);
}

/* for loading CircularProgress */
.sendButton__lT6cm.sendButton__lT6cm span {
  margin-left: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/components/WriteToUsForm/WriteToUsForm.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;;EAEhB,YAAY;;EAEZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;;EAE9B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;;EAE3B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,QAAQ;AACV;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;EAGE,YAAY;;EAEZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;;EAEd,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;;EAEhB,wBAAwB;EACxB,gBAAgB;;EAEhB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;;EAEhB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;;EAEjB,oBAAoB;EACpB,mBAAmB;;EAEnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;AAClB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n}\n\n.writeToUsHeader {\n  margin: 30px 0 6px 20px;\n}\n\n.writeToUsHeaderRedirect {\n  margin-right: 24px;\n  margin-bottom: 5px;\n}\n\n.headerText.headerText {\n  overflow: hidden;\n\n  height: 42px;\n\n  font-size: 32px;\n  font-weight: 600;\n  font-style: normal;\n  line-height: 42px;\n  color: #fff;\n  white-space: nowrap;\n}\n\n.formContainer.formContainer {\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  width: auto;\n  height: 100%;\n}\n\n.formContainer.formContainer form {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n\n  margin: 0;\n  padding: 0 20px;\n}\n\n.formContainer::-webkit-scrollbar {\n  width: 0;\n}\n\n.inputField.inputField,\n.textareaField.textareaField {\n  width: 100%;\n  margin-top: 20px;\n  background-color: #fff;\n  border-radius: 6px;\n}\n\n.inputField.inputField input::placeholder,\n.textareaField.textareaField::placeholder,\ntextarea::placeholder {\n  height: 20px;\n\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n  line-height: 20px;\n  color: #8c8c8c;\n\n  opacity: 1;\n}\n\n.inputField.inputField input,\n.textareaField.textareaField {\n  padding: 12px 16px;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.textareaField.textareaField {\n  resize: vertical;\n\n  width: calc(100% - 32px);\n  min-height: 76px;\n\n  border: none;\n  outline: none;\n}\n\n.sendButton.sendButton {\n  overflow: hidden;\n\n  width: 100%;\n  height: 46px;\n  margin-top: 20px;\n  padding: 6px 16px;\n\n  text-transform: none;\n  white-space: nowrap;\n\n  border-radius: 6px;\n  box-shadow: none;\n}\n\n.sendButton.sendButton:hover {\n  opacity: 0.9;\n  box-shadow: none;\n}\n\n.sendButton.sendButton:disabled {\n  background-color: rgb(255 255 255 / 50%);\n}\n\n/* for loading CircularProgress */\n.sendButton.sendButton span {\n  margin-left: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export var container = `container__Vwz4W`;
export var writeToUsHeader = `writeToUsHeader__i0gzB`;
export var writeToUsHeaderRedirect = `writeToUsHeaderRedirect__HncTB`;
export var headerText = `headerText__e0wk9`;
export var formContainer = `formContainer__vGiak`;
export var inputField = `inputField__WSGfJ`;
export var textareaField = `textareaField__bptdl`;
export var sendButton = `sendButton__lT6cm`;
export default ___CSS_LOADER_EXPORT___;
